module.exports = __webpack_public_path__ + "img/404.42197ccc.png";